const validateField = (name, value, title = name) => {
  title = snakeCaseToTitleCase(title);
  switch (name) {
    case "name":
    case "contact_name":
    case "username":
      if (!value.trim()) return "Please enter " + title + "!";
      if (!validateName(value)) return "Invalid field!";
      return "";
    case "email":
    case "contact_email":
      if (!value.trim()) return "Please enter " + title + "!";
      if (!validateEmail(value)) return "Invalid field!";
      return "";
    case "phone":
    case "contact_phone":
      if (!value.trim()) return "Please enter " + title + "!";
      if (!ValidPhone(value)) return "Invalid field!";
      return "";
    case "tax":
    case "price":
    case "balance":
    case "cost_price":
    case "sale_price":
    case "markup":
    case "min_stock":
    case "max_stock":
    case "amount_paid":
    case "total_discount":
    case "shipping":
    case "qty_recv":
    case "qty_reject":
    case "overage":
    case "temp_high":
    case "temp_low":
    case "deposit":
      if ((value !== 0 && !value) || value === "") return "Please enter " + title + "!";
      if (!ValidAmount(value)) return "Invalid field!";
      if (parseFloat(value) < 0) return title + " should be >= 0!";
      return "";
    case "quantity":
    case "amount":
    case "qty":
    case "kit_qty":
      if (!value || value === "") return "Please enter " + title + "!";
      if (!ValidAmount(value)) return "Invalid field!";
      if (parseFloat(value) < 1) return title + " should be > 0!";
      return "";
    case "city":
    case "description":
    case "gpu_sn":
    case "sku":
    case "box_id":
    case "wb_sn":
    case "result":
      // case "system_sn":
      // case "system_pn":
      if (!value.trim()) return "Please enter " + title + "!";
      if (!ValidText(value)) return "Invalid field!";
      return "";
    case "type":
    case "company":
    case "saleordernote":
    case "category":
    case "sales_category":
    case "unit":
    case "status":
    case "store":
    case "new_store":
    case "part":
    case "child_part":
    case "so":
    case "account_from":
    case "account_to":
    case "account":
    case "customer":
    case "vendor":
    case "payment_status":
    case "ship_method":
    case "role":
    case "employee":
    case "station":
    case "os":
    case "app":
    case "reason":
      if (value === "select" || value === "Select " + title) return "Please select " + title + "!";
      return "";
    case "street_address":
    case "state":
    case "postal_code":
    case "b_street":
    case "b_city":
    case "b_state":
    case "b_zip":
    case "b_country":
    case "s_street":
    case "s_city":
    case "s_state":
    case "s_zip":
    case "s_country":
    case "r_street":
    case "r_city":
    case "r_state":
    case "r_zip":
    case "r_country":
    case "location":
    case "pn_note":
    case "notes":
    case "customer_po":
    case "sales_rep":
    case "vendor_invoice_no":
    case "po_revision":
    case "references":
    case "note":
    case "note_all":
    case "user_note":
    case "tracking_no":
    case "date_code":
    case "lot_number":
    case "sn":
    case "first_sn":
    case "last_sn":
    case "mfg_sn":
    case "role_desc":
    case "other":
    case "comment":
    case "qrscan":
    case "id_no1":
    case "id_no2":
    case "remarks":
    case "reason_note":
      if (value && !ValidText(value)) return "Invalid field!";
      return "";
    case "s_name":
    case "b_to":
    case "s_to":
    case "recv_by":
      if (value && !validateName(value)) return "Invalid field!";
      return "";
    case "website":
      if (value && !ValidWebsite(value)) return "Invalid field!";
      return "";
    case "b_phone1":
    case "b_phone2":
    case "s_phone":
    case "r_phone":
      if (value && !ValidPhone(value)) return "Invalid field!";
      return "";
    case "ship_date":
    case "recv_date":
    case "test":
      if (!value || value === "") return "Invalid field!";
      return "";

    default:
      return "";
  }
};

function snakeCaseToTitleCase(snakeCaseString) {
  const spacedString = snakeCaseString.replace(/_/g, ' ');
  const titleCaseString = spacedString.replace(/\b\w/g, char => char.toUpperCase());
  return titleCaseString;
}

const validateEmail = (mail) => {
  if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
};

function validateName(name) {
  if (/^[A-Za-z0-9\s-,/.+?()&*]+$/.test(name)) {
    return true;
  }
  return false;
}

function validateName2(name) {
  if (typeof name !== "string") return false;
  name = name.trim();

  // allow empty? change if you need to block empty strings:
  if (name.length === 0) return false;

  // Unicode-aware regex:
  // \p{Script=Arabic}  -> Arabic script (covers Urdu letters & diacritics)
  // A-Za-z0-9           -> basic latin letters and digits
  // \u06F0-\u06F9       -> Arabic-Indic digits (۰..۹) often used with Urdu
  // allowed punctuation: space, comma, hyphen, dot, slash, plus, question mark, parentheses, ampersand, asterisk
  // plus Urdu/Arabic punctuation: Arabic question mark (؟), Arabic comma (،), Urdu full stop (۔)
  const re =
    /^[\p{Script=Arabic}A-Za-z0-9\u06F0-\u06F9\s\-,\\/.+?()&*\u061F\u060C\u06D4]+$/u;

  return re.test(name);
}

const ValidPhone = (phone) => {
  // const phoneRegex = /^\d{10}$/;     /^[\d()+\s-]+$/
  if (
    /^(\(\d{1,3}\)\s*)?(\+?\d{1,3}(\s*-?\s*\d{1,3})*|\d{1,3}(\s*-?\s*\d{1,3})*)$/.test(
      phone
    )
  ) {
    return true;
  }
  return false;
};

const ValidWebsite = (web) => {
  if (
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}([a-zA-Z]{2,})(:\d+)?(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;%=]*)?$/.test(
      web
    )
  ) {
    return true;
  }
  return false;
};

const ValidAmount = (amount) => {
  if (/^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/.test(amount)) {
    return true;
  }
  return false;
};

const ValidText = (text) => {
  // if (/^[\w\s\d.,!#@$%^*:&[\]{}()/\\-]+$/u.test(text) && !/[-']{2}|'/.test(text)) {
  return true;
  // }
  // return false;
};

const ValidOrderField = (text) => {
  if (/^[^+-]+$/u.test(text)) {
    return true;
  }
  return false;
};

export const getBase64ImageFromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export {
  validateEmail,
  validateName,
  validateName2,
  ValidPhone,
  ValidWebsite,
  ValidAmount,
  ValidText,
  ValidOrderField,
  validateField
};
